import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import sourceData from './modules/source_data'
import parm from './modules/parm'
import dbMap from './modules/db_map'
import dbPreMap from './modules/db_pre_map'
import solutionProcess from './modules/process'
import assign from './modules/assign'
import loading from './modules/loading'
import dataCase from './modules/case'
import notice from './modules/notice'
import userInfo from './modules/user_info'
import ele from './modules/ele'

import demoMap from './modules/demo_map'

import oilBase from './modules/oil/base'
import oilChecked from './modules/oil/check_data'
import oilInputData from './modules/oil/input_data'
import oilPrediction from './modules/oil/prediction'
import oilPredictionOrder from './modules/oil/prediction_order'
import oilPsDetail from './modules/oil/oil_ps_detail'
import oilHxchx from './modules/oil/oil_hxchx'

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    assign,
    ele,
    sourceData,
    parm,
    dbMap,
    dbPreMap,
    solutionProcess,
    loading,
    dataCase,
    notice,
    userInfo,
    oilBase,
    oilChecked,
    oilInputData,
    oilPrediction,
    oilPredictionOrder,
    demoMap,
    oilPsDetail,
    oilHxchx
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js